import ManageClients from './manage-clients'
export default ManageClients
